import { render, staticRenderFns } from "./StudentProgress.vue?vue&type=template&id=1adca1b0&scoped=true"
import script from "./StudentProgress.vue?vue&type=script&lang=js"
export * from "./StudentProgress.vue?vue&type=script&lang=js"
import style0 from "./StudentProgress.vue?vue&type=style&index=0&id=1adca1b0&prod&lang=css"
import style1 from "./StudentProgress.vue?vue&type=style&index=1&id=1adca1b0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adca1b0",
  null
  
)

export default component.exports